module.exports = __webpack_public_path__ + "media/images/sp_header_btn_close-faf7206240ddbfe8ee5a7d399ec9b774.png";